import { FieldViewModel, isDate, models } from "../omnia"
import { ISnsAssessment, NitrogenAnalysisType } from "../types"
import { INitrogenAnalysis, INitrogenAnalysisAlloc } from "./types"

export function calculateTotalSns(analysis: INitrogenAnalysis, alloc: INitrogenAnalysisAlloc) {

    let sns = analysis.Nitrogen || 0;

    if (alloc) {


        sns += alloc.CropN || 0;

        if (analysis.AnalysisType == models.NitrogenAnalysisType.SMN) {
            sns += alloc.SMN || 0;
        }

    }

    return sns;

}

export function sortNitrogenAnalysis(cropping: FieldViewModel, analysis1: INitrogenAnalysis, analysis2: INitrogenAnalysis) {

    let actual1 = (cropping.currentYear && (analysis1.AnalysisType != NitrogenAnalysisType.FarmAssessment)) ? 0 : 1;

    let actual2 = (cropping.currentYear && (analysis2.AnalysisType != NitrogenAnalysisType.FarmAssessment)) ? 0 : 1;

    let diff = actual1 - actual2;

    if (!diff) {
        diff = isDate(analysis1.SamplingDate) && isDate(analysis2.SamplingDate)
            ? analysis1.SamplingDate.valueOf() - analysis2.SamplingDate.valueOf()
            : 0
    }

    if (!diff) {
        diff = analysis1.NitrogenAnalysisId - analysis2.NitrogenAnalysisId;
    }

    return diff;

}

/**
 * Returns a "virtual" nitrogen analysis, based on a farm assessment of the SNS
 * @param sns
 */
export function getNitrogenAnalysisFromAssessment(holdingId: number, sns: ISnsAssessment): INitrogenAnalysis {

    return {

        HoldingId: holdingId,

        NitrogenAnalysisId: 0,
        LaboratoryId: undefined,

        AnalysisNumber: undefined,
        AnalysisType: NitrogenAnalysisType.FarmAssessment,
        CroppingId: sns.CroppingId,
        Nitrogen: sns.SnsValue || 0,

        SamplingDate: sns.CalcDate,
        CreatedOn: sns.CalcDate,

        Allocations: [

            {
                NitrogenAnalysisAllocId: 0,
                NitrogenAnalysisId: 0,
                FieldId: sns.FieldId,
                CroppingId: sns.CroppingId,

            }

        ]

    };

}
